// extracted by mini-css-extract-plugin
export default {"notFound":"ProjectDetail_notFound__9aRGK"};